/**
 * Incorporation (Pre) — CDD 인스턴스(사람/클라이언트별) 컨텍스트.
 *   CDD stage 를 문서-리스트로 운영: 각 인스턴스 = {docType(개인/법인/Legal Arrangement), values}.
 *   패널이 상태/조작을 provide 하고, 패키지의 CDD stage 가 inject 해 탭·Add·활성 문서를 렌더한다.
 */
import type { InjectionKey, Ref } from 'vue';
import type { CddDocType } from '../cdd/cddFields';

export interface CddInstance {
  id: number;
  docType: CddDocType;
  label: string;
  values: Record<string, string>;
  checkbox: string;
  shRowCount: number;
  boRowCount: number;
}

export interface IncPreCddCtx {
  docs: Ref<CddInstance[]>;
  activeId: Ref<number>;
  select: (id: number) => void;
  add: (docType: CddDocType) => void;
  remove: (id: number) => void;
}

export const INC_PRE_CDD: InjectionKey<IncPreCddCtx> = Symbol('incPreCdd');

export const CDD_TYPE_META: Record<CddDocType, { label: string; icon: string }> = {
  individual: { label: 'Individual', icon: 'mdi-account-outline' },
  legal_person: { label: 'Legal Person', icon: 'mdi-office-building-outline' },
  legal_arrangement: { label: 'Legal Arrangement', icon: 'mdi-file-tree-outline' },
};
